import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { TournamentsResponse } from '../../models/api/responses/tournaments.response';
import { AllTournamentsService } from '../../services/all-tournaments.service';
import { AllTournamentsActions } from '../actions/action-types.action';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';

/**
 * Effects for all tournaments feature
 */
@Injectable()
export class AllTournamentsEffect {
    private actions$ = inject(Actions);
    private allTournamentsService = inject(AllTournamentsService);

    /**
     * Effect to fetch all tournaments
     * Uses switchMap to cancel previous requests when a new one comes in
     */
    fetchAllTournaments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AllTournamentsActions.fetchAllTournaments),
            switchMap(({ payload }) => {
                const { patchExistingTournaments, type, page, filters = {} } = payload;

                return this.allTournamentsService
                    .getAllTournaments(page, filters)
                    .pipe(
                        map((response: TournamentsResponse) =>
                            AllTournamentsActions.fetchAllTournamentsSuccess({
                                payload: {
                                    type,
                                    patchExistingTournaments,
                                    response,
                                },
                            })
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(AllTournamentsActions.fetchAllTournamentsFailure({
                                payload: response,
                            }))
                        )
                    );
            })
        )
    );
}
